import DealerGeolocator from "./DealerGeolocator";
import DealerMap from "./DealerMap";
import DealerAddresses from "./DealerAddresses";
import CountrySelect from "./CountrySelect";

class DealerSearch {
    constructor() {
        this.DISTRIBUTION_CHANNEL_HOME     = '1';
        this.DISTRIBUTION_CHANNEL_BRABUS   = '2';
        this.DISTRIBUTION_CHANNEL_DEALER   = '3';

        this.geolocator = new DealerGeolocator()
        this.dealerMap = null
        this.dealerAddresses = null
        this.lastLocationSearch = null
        /** jQuery objects */
        this.$countrySelect = $('#countrySelect')
        this.$sidebar = $('#sidebar')
        this.$searchLocationContainer = $('#searchLocationContainer')
        this.$filterCheckboxes = $('#searchfilterContainer input[type="checkbox"]')
        this.boatOnly = $('[data-boats-only]').length >= 1;
        this.shopDealers = $('[data-shop-dealers]').length >= 1;
        this.modal = $('[data-modal]').length >= 1;
        this.language = $('[data-language]').data('language');
        this.country = $('[data-country]').data('country');

        window.initMap = () => {
            this.renderCountrySelect()
            this.loadAddressesAndHq()
            // map events
            this.dealerMap = new DealerMap()
            this.dealerMap.get().addListener('dragend', function () {
                $(document).trigger("dealermapcenter.change", ['dragend'])
            })
        }

        $(document).ready(() => {
            this.registerSidebarEvents()
            this.registerCountrySelectEvents()
            this.registerSearchEvents()
            this.registerGlobalEvents()

            this.$filterCheckboxes.on('change', () => $(document).trigger("addressStatus.change", ['init']))
        })
    }

    getFilterValues() {
        let values = [];

        this.$filterCheckboxes
            .filter(':checked')
            .each((index, element) => values.push(element.value))

        return values;
    }

    registerCountrySelectEvents() {
        this.$countrySelect.on('change', () => {
            $(".dealer-search--map-container").show();
            this.$sidebar.removeClass('dealer-search--single-item-mode');

            if (this.$countrySelect.val() === 'Germany' && !this.boatOnly) {
                this.$searchLocationContainer.show();
            } else {
                this.$searchLocationContainer.hide();
            }
            // trigger addressStatus.change
            $(document).trigger("addressStatus.change", ['selectCountry']);
        });
    }

    registerSearchEvents() {
        const $searchLocationButton = $('#searchLocationButton')
        const $searchLocationInput = $('#searchLocation')

        $searchLocationInput.on('keypress', (e) => {
            if (e.which !== 13) {
                return;
            }
            $('#searchLocationButton').trigger('click');
        });

        // start location search
        $searchLocationButton.on('click', () => {
            let cc = this.$countrySelect.val();
            let location = $searchLocationInput.val();
            let search = location + ', ' + cc;// + ", " + zip + " " + city + ", " + cc;

            this.geolocator
                .getCoordinates(search, cc)
                .then((result) => {
                    if (!location) {
                        // empty plz: go to HQ
                        result = DealerAddresses.toLatLng(this.dealerAddresses.getHeadQuarterCoordinates());
                    }
                    this.lastLocationSearch = result;
                    // empty error message
                    $('#errorMsgNoResult').find('.form--error').text('');
                    this.$searchLocationContainer.find('.form--row').removeClass('form--error');
                    this.dealerMap.setCenter(result);

                    // trigger addressStatus.change
                    $(document).trigger("addressStatus.change", ['selectLocation', result]);

                    $('html, body').animate({
                        scrollTop: $('.dealer-search--map-container').offset().top
                    }, 500);

                }, (result) => {
                    $('#errorMsgNoResult')
                        .find('.form--error')
                        .text($('[data-error-message]').data('error-message') + ' ' + location);

                    this.$searchLocationContainer.find('.form--row').addClass('form--error');
                });
        })
    }

    registerGlobalEvents() {
        // second argument for addressStatus.change seems not to be used anymore?
        $(document).on('addressStatus.change', (event, type, geoResult) => {
            this.dealerAddresses.reset()
            this.dealerAddresses.setTypes(this.getFilterValues())
            this.dealerAddresses.filterByCountry(this.$countrySelect.val(), this.geolocator)
            this.dealerAddresses.filterByTypes()
            if (this.boatOnly) {
                this.dealerAddresses.sortByPosition()
            } else {
                // fallback to HQ
                const center = geoResult === undefined
                    ? this.dealerAddresses.getHeadQuarterCoordinates()
                    : {
                        latitude: geoResult.lat(),
                        longitude: geoResult.lng()
                    };
                this.dealerAddresses.sortByDistance(center, this.geolocator)
            }

            this.dealerAddresses.sortByHeadquarter()

            this.dealerMap.render(this.dealerAddresses.join())

            if (this.modal) {
                this.registerDealerChooseEvents()
            }
        })

        $(document).on('dealermapcenter.change', (event, type) => {
            let map = this.dealerMap.get()

            window.setTimeout(() => {
                const center = {
                    latitude: map.getCenter().lat(),
                    longitude: map.getCenter().lng()
                }

                this.dealerAddresses.sortByDistance(center, this.geolocator)
                this.dealerAddresses.sortByHeadquarter()
                // trigger addressStatus.change
                if (type === 'dragend') {
                    this.$sidebar.removeClass('dealer-search--single-item-mode')
                    this.dealerMap.resetMarkerIcon()
                    this.dealerMap.printSidebar(this.dealerAddresses.join())
                }
                // trigger addressStatus.change
                this.dealerMap.updateMarkerLabel(this.dealerAddresses.getCurrent())
            }, 400)
        });
    }

    registerSidebarEvents() {
        this.$sidebar.on('mouseenter mouseleave', "li",  (event) => {
            const status = (event.type === "mouseover") ? 1 : 0
            const address_index = $(event.delegateTarget).data('address-index')

            this.dealerMap.updateMarkerIcon(address_index, status)
        })

        this.$sidebar.on("click", "i", () => {
            this.$sidebar.removeClass('dealer-search--single-item-mode')
            this.dealerMap.resetMarkerIcon()
            this.dealerMap.printSidebar(this.dealerAddresses.join())
        })
    }

    registerDealerChooseEvents() {
        $('a.dealerChoose').on('click', (event) => {
            let addressIdentifier = $(event.target).data('address-identifier')
            let dealerName = $(event.target).data('dealer-name')
            let $dealerSearchName = $('span.dealerName')
            let $dealerSearchContainer = $('#dealerSearchContainer')
            let articleIdentifier = $dealerSearchContainer.data('article-identifier')

            $dealerSearchName.each(function (index, element) {
                $(element).html("<strong>" + dealerName + "</strong>");
                if (addressIdentifier !== 'undefined') {
                    $(element).attr('data-dealer-identifier', addressIdentifier);
                } else {
                    $(element).attr('data-dealer-identifier', 'brabus');
                }
            })

            this.getPriceFromJsonPath(articleIdentifier, addressIdentifier)
            $('#dealerSearchModal').modal('hide');
        });
    }

    /**
     *
     * @param articleIdentifier
     * @param addressIdentifier
     */
    getPriceFromJsonPath(articleIdentifier, addressIdentifier) {
        let distributionChannelNumber = this.DISTRIBUTION_CHANNEL_DEALER;
        if (addressIdentifier === 'undefined') {
            distributionChannelNumber = this.DISTRIBUTION_CHANNEL_BRABUS;
        }
        let distributionChannels = [];
        $("div.product__header").each(function(index, element) {
            if (!$(element).hasClass("d-none")) {
                distributionChannels = $(element).data("distribution-channels");
            }
        });
        if (distributionChannels.length === 0) {
            let variant = $('input[name = variants]:checked');
            distributionChannels = $(variant).data("distribution-channels");
        }

        let distributionChannel = $('input[name = services]#radio-1');
        let priceContainer = $('#priceContainer');
        let label = priceContainer.children('span.price').children('span.price__tag').children('span.price__amount');
        let tooltip = priceContainer.children('span.tooltip-trigger');
        let priceInfo = $('input[name="services"]:checked').data('object-price-info');
        let deliveryTextContainer = $('#deliveryText');

        let price = priceInfo[distributionChannelNumber]['price'] ?? '';
        if (this.language === 'en') {
            price = i18n.get("priceOnRequest");
        }
        if (priceInfo[distributionChannelNumber]['price_extra']) {
            price = price + '<br/>' + priceInfo[distributionChannelNumber]['price_extra'];
        }

        if (priceInfo[distributionChannelNumber]['deliveryText']) {
            deliveryTextContainer.text(priceInfo[distributionChannelNumber]['deliveryText'])
        }

        if (price && priceInfo[distributionChannelNumber]['shippingCosts']) {
            label.show();
            label.html(price);
            tooltip.show();
        } else if (price){
            label.show();
            label.html(price);
            tooltip.hide();
        } else {
            label.hide();
            tooltip.show();
        }

        distributionChannel.val(distributionChannels[distributionChannelNumber]);

        CartDecorator.setTotalPrice();
        CartDecorator.showDeliveryNotice(distributionChannels[distributionChannelNumber]);
    }

    renderCountrySelect() {
        let isBoatsOnlyParam = (this.boatOnly) ? "?getBoatsCountries=1" : ""
        let isShopDealersParam = (this.shopDealers) ? "?getShopDealers=1" : ""
        if (this.shopDealers && this.boatOnly) {
            let isShopDealersParam = "&getShopDealers=1"
        }

        const countriesJsonPath = $('[data-countries-service-path]').data('countries-service-path') + isBoatsOnlyParam + isShopDealersParam

        return fetch(countriesJsonPath)
            .then(response => response.json())
            .then(countries => CountrySelect.build(countries, this.modal))
    }

    loadAddressesAndHq() {

        let hqBoatsOnlyParam = (this.boatOnly) ? "?boatsOnly=1" : "";
        let shopDealersParam = (this.shopDealers) ? "?getShopDealers=1" : ""

        const addressJsonPath = $('[data-address-service-path]').data('address-service-path') + shopDealersParam
        const hqJsonPath = $('[data-hq-service-path]').data('hq-service-path') + hqBoatsOnlyParam

        return Promise.all([
                fetch(addressJsonPath),
                fetch(hqJsonPath)
            ])
            .then(responses => Promise.all([responses[0].json(), responses[1].json()]))
            .then(([addresses, hq]) => {
                this.dealerAddresses = new DealerAddresses(addresses, hq, this.getFilterValues())
                // trigger addressStatus.change
                $(document).trigger("addressStatus.change", ['init'])
            })
    }
}

export default DealerSearch;
